import { observable, action, computed } from 'mobx'
import PT from 'prop-types'
import logger from '@vimcar/shared-utils/logger'

import i18n from '#utils/i18n'
import { O } from '#utils/rx'
import { errorCodes, getErrorCode } from '#utils/foxboxErrors'

const tp = i18n.prefix('components.EditPasswordDialog')

const EditPasswordDialog = (
  { registerObservable },
  { onClose },
  { users },
) => {
  const store = observable({
    step: 1,
    showForm: computed(() => store.step === 1),
    showDone: computed(() => store.step === 2),
    fields: observable.ref([
      'oldPassword',
      'newPassword',
      'confirmNewPassword',
    ]),
    email: computed(() => users.self.email),
    handleSubmit: action(({ oldPassword, newPassword }) => {
      registerObservable(
        users.self
          .updatePassword(oldPassword, newPassword)
          .catch(
            action((err) => {
              const errorCode = getErrorCode(err)
              switch (errorCode) {
                case errorCodes.PASSWORD_WRONG:
                case errorCodes.PASSWORD_DOES_NOT_MATCH:
                  store.error = tp('auth-failed')
                  break
                case errorCodes.INSUFFICIENT_PASSWORD_STRENGTH_NO_DIGIT:
                case errorCodes.INSUFFICIENT_PASSWORD_STRENGTH_NO_UPPERCASE:
                  store.error = tp('password-insufficient')
                  break
                default:
                  logger.error(err)
                  store.error = tp('update-failed')
                  break
              }
              return O.empty()
            }),
          )
          .do(
            action(() => {
              store.step = 2
            }),
          ),
      )
    }),
    handleClickClose: action(() => {
      onClose()
    }),
  })

  return store
}

EditPasswordDialog.propTypes = {
  onClose: PT.func.isRequired,
}

EditPasswordDialog.contextTypes = {
  users: PT.object.isRequired,
}

export default EditPasswordDialog
